import { ApplicationsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  GetApplicationPhasesDocument,
  UpdateApplicationDocument,
  UpdateApplicationMutation,
  UpdateApplicationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateApplication = () => {
  const [update, { loading }] = useMutation(UpdateApplicationDocument, {
    extractorFn: (data: UpdateApplicationMutation) => data.atsMutations.updateAtsApplication,
  })

  return {
    loading,
    updateApplication(variables: UpdateApplicationMutationVariables) {
      return update({
        variables,
        refetchQueries: [ApplicationsDataTableDocument, GetApplicationPhasesDocument],
      })
    },
  }
}
